import {onUnmounted, ref, watch} from '@vue/composition-api'
import useDevicesFilter from '@/views/modules/device/useDevicesFilter'
import store from '@/store'
import mapDeviceStore from "@/views/modules/maps/store/mapDeviceStore";
import filters from "@/views/modules/Utils/filters";

export default function mapDevices() {


  const MAPS_DEVICES = 'map_device'

  if (!store.hasModule(MAPS_DEVICES))
    store.registerModule(MAPS_DEVICES, mapDeviceStore)

  onUnmounted(() => {
    if (store.hasModule(MAPS_DEVICES))
      store.unregisterModule(MAPS_DEVICES)
  })


  const devices = ref([])
  const devicesMeta=ref(null)
  const refDeviceListTable = ref(null)
 // const devicesTableColumns = ['id','name','lastupdate','status','route','actions']
  const devicesTableColumns = ['id','name','lastupdate','status','actions']

  const d_requestStatus = ref(false)

  const totalDevices = ref(0)
  const perPageOptions = [5, 10, 25, 50, 100, 500, 1000]

  const perPage = ref(10)
  const currentPage = ref(1)
  const searchQuery = ref('')

  const sortBy = ref('id')

  const filter = ref({})

  const categoriesFilter = ref([])
  const ownersFilter = ref([])
  const typeFilter = ref(null)
  const groupFilter = ref(null)
  const contractsFilter = ref([])


  const { ownersOptions, groupsOptions, contractsOptions,contractsOptions_orig, categoriesOptions, typesOptions } = filters('device')

  watch([perPage, currentPage, searchQuery, categoriesFilter, ownersFilter,
    typeFilter, groupFilter, contractsFilter], () => {

    filter.value = {
      ...(ownersFilter.value && {owners: ownersFilter.value}),
      ...(typeFilter.value && {type: typeFilter.value}),
      ...(groupFilter.value && {group: groupFilter.value}),
      ...(categoriesFilter.value && {categories: categoriesFilter.value}),
      ...(contractsFilter.value && {contracts: contractsFilter.value}),
      ...(searchQuery.value && {q: searchQuery.value})
    }

    fetchDevices()

  })

  const fetchDevices = () => {

    d_requestStatus.value = true
    store.dispatch('map_device/fetchDevices', {
        q: searchQuery.value,
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      }).then(response => {
        d_requestStatus.value = false

        const { data } = response.data.data
        const { total, per_page } = response.data.data.meta
        devicesMeta.value=response.data.data.meta
        devices.value = data
        totalDevices.value = total
      }).catch(() => d_requestStatus.value = false)
  }


  return {

    devices,
    fetchDevices,
    d_requestStatus,
    devicesTableColumns,

    refDeviceListTable,

    perPage,
    perPageOptions,
    currentPage,
    filter,
    searchQuery,
    totalDevices,

    contractsOptions, categoriesOptions,contractsOptions_orig,
    groupsOptions,
    typesOptions,
    ownersOptions,

    contractsFilter, groupFilter,
    typeFilter, categoriesFilter, ownersFilter,
    devicesMeta,
  }
}
